import { load } from '~/loaders/appLoader';

load();
